import { Pipe, PipeTransform } from '@angular/core';
import formatScheduleTime from '../../string/formatScheduleTime';

@Pipe({name: 'FormatTime', standalone: true})
export class FormatTimePipe implements PipeTransform {

    constructor() { }

    /**
     * Transforms a string time from HH:mm:ss to h:mm A
     *
     * @example "18:30:00" => "6:30 PM"
     *          "04:00:00" => "4 AM"
     *
     * @param value the value to transform.
     * @returns the transformed value.
     */
    transform(value: string): string {
        return formatScheduleTime(value);
    }
}
